<template>
    <div class="font-size-xlg">
        <span v-for="(icon, index) in icons" :key="icon.iconName">
            <font-awesome-icon :icon="icon.iconName" :title="icon.iconName"/>&nbsp;
            <br v-if="(index + 1) % 10 === 0"/>
        </span>
    </div>
</template>

<script>
import fontawesomeIcons from "../fontawesome-icons";

export default {
    computed: {
        icons() {
            return Object.values(fontawesomeIcons)
        }
    }
}
</script>

<style scoped>

</style>
